// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "* {\n  box-sizing: border-box; }\n\nul * {\n  list-style: none; }\n\na {\n  text-decoration: none; }\n", ""]);
// Exports
module.exports = exports;
